export const invoiceWorkspaceEn = {
 view:"View",
 pProcessOn:"Enabled",pProcessOff:"Not enabled",
  roundedBase: "Rounded base",
  totalMismatch:
    "Saved total differs from the calculated total. Review before issuing; the saved total is retained.",
  bankSnapshot: "Payment details saved on the document",
  bank_beneficiary: "Beneficiary",
  bank_beneficiaryBank: "Beneficiary bank",
  bank_bankAddress: "Bank address",
  bank_accountNumberHkd: "Account (HKD)",
  bank_accountNumberUsd: "Account (USD)",
  bank_accountNumberRmb: "Account (RMB)",
  bank_swiftCode: "SWIFT code",
  noSources:
    "No unassigned PI matches. Archived invoices can be reviewed and restored from the Archived list.",
  chooseLines: "Choose what to invoice. Each line is pre-filled with everything still left on it.",
  line: "Line",
  ordered: "On the PI",
  alreadyInvoiced: "Already invoiced",
  remaining: "Left to invoice",
  invoiceNow: "Invoice now",
  nothingLeft: "Every line on this PI has already been invoiced in full. Nothing is left to invoice.",
  invoice_line_exceeds: "One line asks for more than is left on it. Lower the quantity and try again.",
  invoice_no_lines: "Choose at least one line with a quantity above zero.",
  chooseSource: "Choose source PI",
  editorHint:
    "Choose a PI and review its complete document details. New invoices copy the PI and use the issue date when created. Existing invoices allow the displayed overrides.",
  issueFields: "Invoice fields",
  previewSource: "Document details · review before saving",
  replaceSource: "Replace source PI?",
  replaceHint:
    "This replaces the customer, recipients, prices, bank details and all lines using the reviewed PI. The invoice number stays the same.",
  viewArchived: "View archived invoice",
  preview: "Print preview",
  archive: "Archive invoice",
  restore: "Restore invoice",
  restoreHint:
    "Restore invoice {{number}} with its original number and saved details. Archive history is retained.",
  createDelivery: "Create delivery note",
  openDelivery: "Open existing delivery note",
  deliveryHint:
    "Review the recipient, variants, quantities and LOTs. If a related delivery note already exists, it will open for review. This does not confirm physical delivery.",
  archived: "Archived",
  active: "Active",
  lifecycle: "Invoice state",
  from: "Invoice date from",
  to: "Invoice date to",
  invoice_archived:
    "This PI has an archived invoice. Review and restore that invoice instead of creating another number.",
  invoice_parent_archived:
    "Restore the source PI before restoring this invoice.",
  invoice_source_changed:
    "The PI changed after preview. Reload the source and review before saving.",
  invoice_changed:
    "This invoice changed while you were working. Reload and review the latest saved version.",
  invoice_delivery_locked:
    "Related delivery notes exist. Review or archive them before editing or archiving this invoice.",
};
export const invoiceWorkspaceVi = {
 view:"Xem",
 pProcessOn:"Bật",pProcessOff:"Không bật",
  roundedBase: "Giá trị sau làm tròn",
  totalMismatch:
    "Tổng đã lưu khác tổng tính lại. Kiểm tra trước khi phát hành; hệ thống giữ tổng đã lưu.",
  bankSnapshot: "Thông tin thanh toán lưu trên chứng từ",
  bank_beneficiary: "Người thụ hưởng",
  bank_beneficiaryBank: "Ngân hàng thụ hưởng",
  bank_bankAddress: "Địa chỉ ngân hàng",
  bank_accountNumberHkd: "Tài khoản (HKD)",
  bank_accountNumberUsd: "Tài khoản (USD)",
  bank_accountNumberRmb: "Tài khoản (RMB)",
  bank_swiftCode: "Mã SWIFT",
  noSources:
    "Không có PI chưa lập hóa đơn phù hợp. Xem và khôi phục hóa đơn cũ tại danh sách Đã lưu trữ.",
  chooseLines: "Chọn phần muốn xuất hóa đơn. Mỗi dòng đã điền sẵn toàn bộ phần còn lại của nó.",
  line: "Dòng hàng",
  ordered: "Trên PI",
  alreadyInvoiced: "Đã xuất hóa đơn",
  remaining: "Còn xuất được",
  invoiceNow: "Xuất lần này",
  nothingLeft: "Mọi dòng trên PI này đã xuất hóa đơn đủ. Không còn gì để xuất.",
  invoice_line_exceeds: "Có dòng đòi nhiều hơn phần còn lại của chính nó. Hạ số lượng rồi thử lại.",
  invoice_no_lines: "Chọn ít nhất một dòng có số lượng lớn hơn 0.",
  chooseSource: "Chọn PI nguồn",
  editorHint:
    "Chọn PI và kiểm tra đầy đủ nội dung. Hóa đơn mới sao chép PI, lấy ngày phát hành lúc tạo. Hóa đơn hiện có cho phép chỉnh các trường bên dưới.",
  issueFields: "Thông tin hóa đơn",
  previewSource: "Nội dung chứng từ · kiểm tra trước khi lưu",
  replaceSource: "Đổi PI nguồn?",
  replaceHint:
    "Thao tác này thay khách hàng, người nhận, giá, ngân hàng và toàn bộ dòng hàng theo PI đã kiểm tra. Số hóa đơn giữ nguyên.",
  viewArchived: "Xem hóa đơn đã lưu trữ",
  preview: "Xem trước bản in",
  archive: "Lưu trữ hóa đơn",
  restore: "Khôi phục hóa đơn",
  restoreHint:
    "Khôi phục hóa đơn {{number}} với số cũ và nội dung đã lưu. Lịch sử lưu trữ được giữ lại.",
  createDelivery: "Tạo phiếu giao hàng",
  openDelivery: "Mở phiếu giao hàng hiện có",
  deliveryHint:
    "Kiểm tra người nhận, biến thể, số lượng và LOT. Nếu đã có phiếu liên quan, hệ thống sẽ mở phiếu đó. Thao tác này chưa xác nhận hàng đã giao.",
  archived: "Đã lưu trữ",
  active: "Đang sử dụng",
  lifecycle: "Tình trạng hóa đơn",
  from: "Ngày hóa đơn từ",
  to: "Ngày hóa đơn đến",
  invoice_archived:
    "PI đã có hóa đơn được lưu trữ. Xem và khôi phục hóa đơn đó thay vì tạo số mới.",
  invoice_parent_archived: "Khôi phục PI nguồn trước khi khôi phục hóa đơn.",
  invoice_source_changed:
    "PI đã thay đổi sau khi xem trước. Tải lại PI và kiểm tra trước khi lưu.",
  invoice_changed:
    "Hóa đơn đã thay đổi trong lúc bạn thao tác. Tải lại và kiểm tra bản mới nhất.",
  invoice_delivery_locked:
    "Đã có phiếu giao hàng liên quan. Kiểm tra hoặc lưu trữ chúng trước khi sửa hoặc lưu trữ hóa đơn.",
};
export const invoiceWorkspaceZh = {
 view:"查看",
 pProcessOn:"启用",pProcessOff:"未启用",
  roundedBase: "四舍五入后金额",
  totalMismatch: "已保存总额与计算总额不同。开具前请核对；保留已保存总额。",
  bankSnapshot: "单据保存的付款信息",
  bank_beneficiary: "收款人",
  bank_beneficiaryBank: "收款银行",
  bank_bankAddress: "银行地址",
  bank_accountNumberHkd: "账户（HKD）",
  bank_accountNumberUsd: "账户（USD）",
  bank_accountNumberRmb: "账户（RMB）",
  bank_swiftCode: "SWIFT 代码",
  noSources: "没有符合的未分配 PI。可从已归档列表查看并恢复旧发票。",
  chooseLines: "选择要开立的部分。每行已预填该行剩余的全部数量。",
  line: "品项",
  ordered: "PI 数量",
  alreadyInvoiced: "已开立",
  remaining: "尚可开立",
  invoiceNow: "本次开立",
  nothingLeft: "此 PI 的每一行都已全数开立，没有剩余可开立的数量。",
  invoice_line_exceeds: "有一行要求的数量超过其剩余量。请调低数量后再试。",
  invoice_no_lines: "请至少选择一行且数量大于 0。",
  chooseSource: "选择来源 PI",
  editorHint:
    "选择 PI 并核对完整内容。新发票复制 PI，以创建当日为开票日期。现有发票可修改下列字段。",
  issueFields: "发票信息",
  previewSource: "单据内容 · 保存前请核对",
  replaceSource: "更换来源 PI？",
  replaceHint:
    "依已核对 PI 替换客户、收件人、价格、银行信息及所有明细。发票号码不变。",
  viewArchived: "查看已归档发票",
  preview: "打印预览",
  archive: "归档发票",
  restore: "恢复发票",
  restoreHint: "恢复发票 {{number}} 的原号码及已保存内容。保留归档历史。",
  createDelivery: "创建送货单",
  openDelivery: "打开现有送货单",
  deliveryHint:
    "核对收件人、规格、数量及 LOT。若已有相关送货单，将打开该单据。此操作不代表已实际交货。",
  archived: "已归档",
  active: "有效",
  lifecycle: "发票状态",
  from: "发票起始日期",
  to: "发票结束日期",
  invoice_archived: "此 PI 已有归档发票。请查看并恢复该发票，无须创建新号码。",
  invoice_parent_archived: "请先恢复来源 PI，再恢复发票。",
  invoice_source_changed: "PI 在预览后已更改。请重新加载并核对后保存。",
  invoice_changed: "操作期间发票已更改。请重新加载并核对最新版本。",
  invoice_delivery_locked:
    "已有相关送货单。修改或归档发票前，请先查看或归档送货单。",
};
